import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, Loader } from 'lucide-react';

const PaymentCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const status = searchParams.get('status') || 'verifying';
  const reference = searchParams.get('reference') || searchParams.get('trxref');

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-lg overflow-hidden">
        
        {/* Header */}
        <div className="h-2 bg-gradient-to-r from-orange-500 to-amber-500" />

        <div className="p-10 text-center">
          
          {status === 'verifying' && (
            <>
              <div className="flex justify-center mb-6">
                <Loader className="w-20 h-20 text-orange-500 animate-spin" />
              </div>
              <h1 className="text-2xl font-semibold text-gray-800 mb-3">
                Verifying Payment
              </h1>
              <p className="text-gray-600">
                Please wait while we confirm your transaction...
              </p>
              {reference && (
                <p className="text-xs text-gray-400 mt-6 font-mono">
                  Ref: {reference}
                </p>
              )}
            </>
          )}

          {status === 'success' && (
            <>
              <div className="flex justify-center mb-6">
                <CheckCircle className="w-24 h-24 text-green-500" />
              </div>
              <h1 className="text-4xl font-bold text-green-600 mb-2">
                Success!
              </h1>
              <p className="text-xl text-gray-700 mb-8">
                Payment Completed Successfully
              </p>
              
              {reference && (
                <div className="bg-green-50 border border-green-100 rounded-2xl p-4 mb-8">
                  <p className="text-sm text-green-700">Transaction Reference</p>
                  <p className="font-mono text-green-800 font-medium">{reference}</p>
                </div>
              )}

              <button
                onClick={() => navigate('/order-success')}
                className="w-full bg-green-600 text-white py-4 rounded-2xl font-semibold hover:bg-green-700 transition"
              >
                View Order Details
              </button>
            </>
          )}

          {status === 'failed' && (
            <>
              <div className="flex justify-center mb-6">
                <XCircle className="w-24 h-24 text-red-500" />
              </div>
              <h1 className="text-3xl font-bold text-red-600 mb-3">
                Payment Failed
              </h1>
              <p className="text-gray-600 mb-8">
                We couldn't process your payment. Please try again.
              </p>

              <div className="space-y-3">
                <button
                  onClick={() => navigate(-1)}
                  className="w-full bg-gray-800 text-white py-4 rounded-2xl font-semibold hover:bg-gray-900 transition"
                >
                  Try Again
                </button>
                
                <button
                  onClick={() => navigate('/')}
                  className="w-full border border-gray-300 py-4 rounded-2xl font-semibold hover:bg-gray-50 transition"
                >
                  Go to Homepage
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentCallback;